




import { Component, Vue, Watch } from 'vue-property-decorator'
import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue'
import moment from 'moment'

class ReviewsItem {
  id: string = ''
  outletCode: string = ''
  rate: number = 0
  review: string = ''
  contactName: string = ''
  phoneNumber: string = ''
  userChoose: string = ''
}

@Component({
  components: {}
})
class Reviews extends RemoteDataTable<ReviewsItem> {
  public pageTitle: string = 'Reviews'
  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({
      key: 'outletCode',
      label: 'Outlet Code',
      filter:
        this.$store.state.currentUser.Type === 'Admin' ? 'input' : 'select',
      options: [
        {
          text: 'All',
          value: this.$store.state.currentUser.OutletCodes.join(',')
        }
      ].concat(
        this.$store.state.currentUser.OutletCodes.map(item => ({
          text: item,
          value: item
        }))
      )
    }),
    new RemoteDataField({ key: 'contactName', label: 'User Name' }),
    new RemoteDataField({ key: 'contactPhone', label: 'Phone Number' }),
    new RemoteDataField({ key: 'rate', label: 'Rate' }),
    new RemoteDataField({
      key: 'userChoose',
      label: 'User Like/Dislike'
    }),
    new RemoteDataField({
      key: 'review',
      label: 'Review',
      disableFilter: true,
      class: 'break-all'
    }),
    new RemoteDataField({
      key: 'createdAt',
      label: 'Date Created',
      formatter: value => moment(value)
    })
  ]
  public uid: any = localStorage.getItem('UID')
  // to get page data
  get items(): ReviewsItem[] {
    return this.$store.getters.GetAllUserReviews
  }

  get paging(): ReviewsItem[] {
    return this.$store.getters.PagingUserReview
  }

  get sorting(): ReviewsItem[] {
    return this.$store.getters.SortingUserReview
  }

  get filtering(): ReviewsItem[] {
    return this.$store.getters.FilteringUserReview
  }
  deleteItem() {}

  mounted() {
    if (this.$store.state.currentUser.Type !== 'Admin') {
      this.$store.commit('SET_USER_REVIEW_FILTERING_REVIEW', {
        ...this.filtering,
        outletCode: this.$store.state.currentUser.OutletCodes.join(',')
      })
      this.$store.dispatch('GetAllUserReviews')
    }
  }

  formatterForPercent(value) {
    return value ? `${value}%` : '-'
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingUserReviews', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc,
      uid: this.uid
    })
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringUserReviews', {
      isResetFilter: isResetFilter,
      uid: this.uid
    })
  }

  checkUserAndGetData() {
    this.$store.dispatch('GetAllUserReviews', this.uid)
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.review.pagingUserReview.page = 1
    }
    this.checkUserAndGetData()
  }

  setPerPage(page) {
    this.$store.state.review.pagingUserReview.size = page
    this.checkUserAndGetData()
  }
}
@Component({
  components: {
    Reviews
  }
})
export default class List extends Vue {}
